/**
 * Restyles the Gorgias chat to the Monk look:
 * - Launcher ("Contact us", bottom corner): black fill, 1px #FCF9F5 border, #FCF9F5 label, no gradient.
 * - Launcher and chat window: small 3px corners instead of the app's large rounded ones
 *   (avatars stay round).
 * Gorgias renders inside its own iframes, so theme CSS can't reach in; this script styles the iframe
 * elements from the page and injects a small stylesheet into each frame once it appears. If Gorgias
 * ever serves a frame cross-origin, the browser blocks access and that part keeps its app styling.
 */
const RADIUS = '3px';

const OUTER_CSS = `
  #gorgias-chat-container iframe,
  #gorgias-chat-container [id^="chat"] {
    border-radius: ${RADIUS} !important;
  }
`;

const CORNERS_CSS = `
  *:not(img):not([class*="avatar" i]):not([class*="avatar" i] *):not([class*="dot" i]) {
    border-radius: ${RADIUS} !important;
  }
  html, body { border-radius: ${RADIUS} !important; }
`;

const LAUNCHER_CSS = `
  button, [role="button"] {
    background: #000 !important;
    background-image: none !important;
    border: 1px solid #FCF9F5 !important;
    color: #FCF9F5 !important;
    box-shadow: none !important;
  }
  button *:not(svg):not(svg *), [role="button"] *:not(svg):not(svg *) {
    background: transparent !important;
    background-image: none !important;
    color: #FCF9F5 !important;
  }
  button svg, button svg *, [role="button"] svg, [role="button"] svg * {
    fill: #FCF9F5 !important;
    color: #FCF9F5 !important;
  }
`;

function addOuterStyle() {
  if (document.getElementById('monk-chat-outer-style')) return;
  const style = document.createElement('style');
  style.id = 'monk-chat-outer-style';
  style.textContent = OUTER_CSS;
  document.head.appendChild(style);
}

function isLauncher(frame) {
  return frame.id === 'chat-button' || /button/i.test(frame.title || '');
}

function styleFrame(frame) {
  try {
    const doc = frame.contentDocument;
    if (!doc || !doc.head || doc.getElementById('monk-chat-style')) return;
    const style = doc.createElement('style');
    style.id = 'monk-chat-style';
    style.textContent = CORNERS_CSS + (isLauncher(frame) ? LAUNCHER_CSS : '');
    doc.head.appendChild(style);
  } catch (error) {
    // Cross-origin frame: leave the app's own styling in place.
  }
}



function scan() {
  document.querySelectorAll('#gorgias-chat-container iframe').forEach((frame) => {
    styleFrame(frame);
    if (!frame.dataset.monkStyled) {
      frame.dataset.monkStyled = 'true';
      frame.addEventListener('load', () => styleFrame(frame));
    }
  });
}

// The chat window frame is only created when a visitor opens the chat, so keep watching
// (batched to one scan per frame).
let queued = false;
const observer = new MutationObserver(() => {
  if (queued) return;
  queued = true;
  requestAnimationFrame(() => {
    queued = false;
    scan();
  });
});

addOuterStyle();
observer.observe(document.body, { childList: true, subtree: true });
scan();
